import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-dynamic-field-label',
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './dynamic-field-label.html',
})
export class DynamicFieldLabel
{  
  public label:string = '';
  public type:string = '';
  public classes:string = '';
  constructor() { }

}
